// NPM
import React, { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { forEach, isEmpty, isNil, find, map, groupBy, filter, cloneDeep, pick, isNumber } from 'lodash';
import moment from "moment";
import _, { omitBy } from 'lodash';

// ANT COMPONENT
import { Space, Table, Row, Col, Checkbox, Input, Alert, Radio, Divider } from 'antd';
import {
  Button,
  SkeletonLoader,
  BasicModal,
  Loader,
  ActionMenu,
  AlertBox,
  SelectInput,
  TextInput,
  DataTable
} from '@life-line-lab/components-react';
import { CloseCircleOutlined, DownOutlined } from '@ant-design/icons';

// STYLE
import '../product.scss';
import './product-checkout.scss';

// HELPERS
import { encode } from "Helpers/enc";
import { toaster } from 'Helpers/toaster';

// HOOKS
import useSession from "Hooks/session.hook";

// COMPONENTS
import statesCities from 'Components/profile/profile-details/addresses/country_MY.json'
import CountrySelector from 'Components/shared/country-selector/country-selector';
import { UpdateAddressFormSchema } from 'Components/shared/add-new-address/add-new-address.validation';
import VoucherDeals from 'Components/voucher-deals';

// UTILS
import normalize from '../../../utils/normalizer';
import errorHandler from '../../../utils/error-handler';

// JSON ADDRESS
import countriesStates from '../../profile/profile-details/addresses/countriesStates.json'

// RECOIL ATOM
import { LocalCartAtom } from 'Recoil/order.atom'
import { PlatformVoucherAtom, ProductVoucherAtom } from 'Recoil/voucher.atom';
import { getWithExpiry } from 'Helpers/getset-with-expiry';
import axios from 'axios';
import { cancelOrder } from 'Services/order.services';
import { RiTruckLine } from 'react-icons/ri';

interface ProductCheckoutProps {
  status: string;
  handleSubmit: (input: any) => void;
  handleUpdate: ({ }: any) => void;
  profileStatus: any
  profileInfoObj: any;
  fetchProfileData: () => void;
  fetchShippingCosts: (input: any) => void;
  fetchPlatformVoucherList: (input: any) => void;
  fetchItemVoucherList: (input: any) => void;
  verifyVoucher: (filterInput: any) => any;
  shippingCosts: any;
  checkoutPlatFormVoucherList: any;
  checkoutItemVoucherList: any;
  quotationID?: string;
}

interface HandleVoucherInterface {
  /** Order Type [PRODUCT || VOUCHER] */
  type: string;
  /** Voucher ID */
  id: string;
  /** Voucher Name */
  name: string;
  /** To Tell The Func Whether T0 Apply Or Unapply */
  applyBoolean: boolean;
  /** Voucher Type [SHIPPING || PURCHASE || ORDER] */
  voucherType: string;
  /** [PERCENTAGE || FIAT] */
  discountType: string;
  /** Discount Value */
  discountValue: string;
  /** Supplier ID Of The Order */
  supplierID: string;
  /** Optional For Platform, To Handle Dropdown Positioning */
  className?: string;
}

export type OrderDataType = {
  receiverID: string,
  orderedBy: string,
  orderDate: moment.Moment | Date | string,
  supplierID: string,
  orderType: 'ECOM_RETAIL',
  items: any[] | null,
  shippingAddress: any,
  reqStatus: 'NORMAL',
  paymentDetails: any,
  payment_data?: any,
  remarks: string | null,
  status: 'OPEN',
  deliveryInfo?: any,
}

const ProductCheckout: React.FC<ProductCheckoutProps> = ({
  status,
  shippingCosts,
  fetchShippingCosts,
  profileInfoObj,
  profileStatus,
  handleSubmit,
  handleUpdate,
  fetchProfileData,
  fetchPlatformVoucherList,
  fetchItemVoucherList,
  checkoutPlatFormVoucherList,
  checkoutItemVoucherList,
  verifyVoucher,
  quotationID,
}) => {

  // VARIABLE DECLARATION
  const { t, i18n} = useTranslation();
  const history = useHistory<any>();
  const {TextArea} = Input;
  
  // INITIALISE VARIABLE
  const shippingOptions = [
    { label: t('option.standardDelivery'), amount: 5, value: 'STANDARD' },
    { label: t('option.expressDelivery'), amount: 7, value: 'EXPRESS' },
    { label: t('option.nxtDayDelivery'), amount: 14, value: 'NEXT_DAY' }
  ]

  const initialAddrInput = {
    type: '',
    street1: '',
    street2: '',
    postcode: '',
    city: '',
    state: '',
    country: 'MY'
  }

  const initialInput = {
    totalAmount: 0.00,
    // shippingFee: 5.00,
    totalToPay: 0.00,
    // shippingType: shippingOptions[0]
    shipping: shippingOptions[0],
    totalShipping: 0.00,
  }

  let initalError = {}
  let initShippingModal = {
    isOpen: false,
    selectedData: {}
  }

  // USE STATE
  const [input, setInput] = useState<any>(initialInput);
  const [cartData, setCartData] = useState<any>([]);
  const [groupedList, setGroupedList] = useState<any>([]);
  const [voucherGroupedList, setVoucherGroupedList] = useState<any>([]);
  const [noShippingProductGroupedList, setNoShippingProductGroupedList] = useState<any>([]);
  const [addressInput, setAddressInput] = useState<any>(initialAddrInput);
  const [addrList, setAddrList] = useState([])
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selAddress, SetselAddress] = useState(0);
  const [shippingModal, SetShippingModal] = useState<any>(initShippingModal);
  const [selShipping, setSelShipping] = useState(input.shipping);
  const [newAddrOpen, setNewAddrOpen] = useState(false)
  const [isError, setError] = useState<any>(initalError);
  const [modalPlaceOrder, setModalPlaceOrder] = useState<boolean>(false);
  const [voucherCodeInput, setVoucherCodeInput] = useState<any>([]);
  const [stateOption, setStateOption] = useState<any>([]);
  const [citiesOption, setCitiesOption] = useState<any>([]);
  const [defaultDaysOfShipping, setDefaultDaysOfShipping] = useState<any>({
    inStock: 4,
    preOrder: 11,
  })

  // USE RECOIL STATE
  const [appliedPlatformVoucher, setAppliedPlatformVoucher] = useRecoilState<any>(PlatformVoucherAtom);
  const [appliedProductVoucher, setAppliedProductVoucher] = useRecoilState<any>(ProductVoucherAtom);
  const [localCartState, setLocalCartState] = useRecoilState<any>(LocalCartAtom);

  useEffect(() => {
    let states: Array<{ value: string; label: string; }> = [];
    map(countriesStates, (country: { name: string, code: string, states: string[] }) => {
      if (addressInput.country == country.code) {
        return country.states.map((name) => {
          states.push({ value: name, label: name });
        })
      }
    });
    setStateOption(states);
  }, [addressInput.country])

  useEffect(() => {
    console.debug(JSON.stringify(groupedList, null, 2));
  }, [groupedList])

  //Retrieve cities list based on selected country
  useEffect(() => {
    let cities: any = [];
    map(statesCities.STATES, (state) => {
      if (addressInput.state === state.NAME) {
        return state.CITIES.map((city) => {
          cities.push({ value: city.NAME, label: city.NAME })
        });
      }
    });
    setCitiesOption(cities);
  }, [addressInput.state])


  // pass cityCode when city changes
  useEffect(() => {
    map(statesCities.STATES, (state) => {
      state.CITIES.map((city) => {
        if (addressInput.city === city.NAME) {
          setAddressInput({ ...addressInput, cityCode: city.CODE });
        }
      })
    });
  }, [addressInput.city])

  // pass stateCode when state changes
  useEffect(() => {
    map(statesCities.STATES, (state) => {
      if (addressInput.state === state.NAME) {
        setAddressInput({ ...addressInput, stateCode: state.CODE });
      }
    });
  }, [addressInput.state])

  // COLUMN TEMPLATE FOR TABLE
  const columns = [
    {
      title: t('label.product'),
      dataIndex: ['productData', 'selectedVariant'],
      width: '50%',
      render: (_: any, record: any) => {
        return (
          <div style={{ display: 'flex' }}>
            <div className="img-border">
              <img
                alt={t('alt.logo')}
                // src={find(record.productData.productImages, (productImg) => {
                //   return productImg.variantCode === record.selectedVariant.variantCode
                // })?.image || '/assets/images/product-placeholder.png'}
                // src={record.productData.featuredImage?.image || '/assets/images/product-placeholder.png'}
                src={record?.variantImg}
                width={50}
              />
            </div>
            <div style={{ flexGrow: 1 }}>
              <a onClick={() => onProductClick(record.productData)}
                className="cart-product-name">{record.productData.product.productName}</a>
              <div className="my-5 color-secondary font-13" style={{ marginLeft: '1em' }}>
                <strong>{t('label.variation')}: </strong>
                <span><strong>{record.selectedVariant.variantName}&nbsp;</strong></span>
                {record.productType == 'VOUCHER' ?
                  <span className="custom-badge dark-pink">VOUCHER</span> : null}
              </div>
              <div className="ml-10">
              {record?.productType === 'NO_SHIPPING' ? 
              <h5 className="items-direct-beneficiary-badge my-10">
                <RiTruckLine className="truck-icon" size={20}/>
                <span>{t('label.itemsWillBeSendToBeneficiary')}</span>
              </h5> : null}
              </div>
            </div>

          </div>
        )
      }
    },
    {
      title: t('label.unitPrice'),
      dataIndex: ['selectedVariant'],
      render: (_: any, record: any) => {
        return (
          <div>
            RM {parseFloat(record.selectedVariant.value).toFixed(2)}
          </div>
        )
      }
    },
    {
      title: t('label.quantity'),
      dataIndex: ['quantity'],
      render: (_: any, record: any) => {
        return (
          <div>
            {record.quantity}
          </div>
        )
      }
    },
    {
      title: t('label.totalPrice'),
      dataIndex: ['productSubtotal'],
      render: (_: any, record: any) => {
        return (
          <div>
            RM {(parseFloat(record.selectedVariant.value) * parseFloat(record.quantity)).toFixed(2)}
          </div>
        )
      }
    }
  ]

  const columnsMobile = [
    {
      title: null,
      dataIndex: ['productData', 'selectedVariant'],
      render: (_: any, record: any) => {
        return (
          <div style={{ display: 'flex', flexDirection: 'column', rowGap: 10 }}>
            <div>
              <img
                alt={t('alt.logo')}
                // src={record.productData.featuredImage?.image || '/assets/images/product-placeholder.png'}
                src={record?.variantImg}
                width={50}
              />
            </div>

            <div>
              <a
                onClick={() => onProductClick(record.productData)}>{record.productData.product.productName}</a>
            </div>

            <div className="my-5 color-secondary font-13">
              <strong>{t('label.variation')}: </strong>
              <span><strong>{record.selectedVariant.variantName}&nbsp;</strong></span>
              {record.productType == 'VOUCHER' ?
                <span className="mt-5"><br /><span className="custom-badge dark-pink">VOUCHER</span></span> : null}
              <div>
              {record?.productType === 'NO_SHIPPING' ? 
              <h5 className="items-direct-beneficiary-badge my-10">
                <RiTruckLine className="truck-icon" size={20}/>
                <span>{t('label.itemsWillBeSendToBeneficiary')}</span>
              </h5> : null}
              </div>
            </div>

            <div>
              RM {parseFloat(record.selectedVariant.value).toFixed(2)}
            </div>

            <div style={{ display: 'flex' }}>
              <span>{t('label.quantity')}: {record.quantity}</span>
            </div>
            <div>
              {t('label.total')}:
              RM {(parseFloat(record.selectedVariant.value) * parseFloat(record.quantity)).toFixed(2)}
            </div>
          </div>
        )
      }
    }
  ];


  useEffect(() => {
    if (localCartState.list.length) {
      let localCartStateList = filter(localCartState.list, item => {
        return !item.productData.disablePurchase
      })
      setCartData(localCartStateList)
    }
  }, [localCartState])

  useEffect(() => {
    if (input.shippingAddress && localCartState.list.length) {
      let shippingOrders = map(cloneDeep(localCartState.shippingCostObj?.orders), shipping => {
        shipping.state = input.shippingAddress.state;
        return shipping;
      })
      let shippingReqObj = {
        ...localCartState.shippingCostObj,
        orders: shippingOrders
      }
      fetchShippingCosts(shippingReqObj);
    }
  }, [input.shippingAddress])


  useEffect(() => {
    if (!isNil(cartData) && shippingCosts.length) {
      let totalAmount = 0;
      let totalShipping = 0;
      forEach(cartData, cartObj => {
        totalAmount += (parseFloat(cartObj.selectedVariant.value) * parseFloat(cartObj.quantity))
      })

      // * NORMAL PRODUCTS AS ONE ORDER
      let supplierGroup = groupBy(filter(cartData, cart => {
        return cart.productType != 'VOUCHER' && cart.productType !== 'NO_SHIPPING'
      }), cartObj => {
        return cartObj.productData.orgID;
      })

      let groupedCart = map(supplierGroup, (data, id) => {
        let amount: any = shippingCosts.find(x => x.supplierID === id);
        totalShipping += amount?.rateAfterSST ? amount?.rateAfterSST : 0;
        return {
          supplierID: id,
          shipping: {
            label: t('option.standardDelivery'),
            amount: amount?.rateAfterSST ? amount?.rateAfterSST : 0,
            value: 'STANDARD'
          },
          supplierData: data[0]?.productData?.orgData,
          products: data
        }
      })

      // * TELEMED VOUCHER PRODUCTS AS ONE ORDER
      let voucherSupplierGroup = groupBy(filter(cartData, cart => {
        return cart.productType == 'VOUCHER'
      }), cartObj => {
        return cartObj.productData.orgID;
      })

      let groupedVoucherCart = map(voucherSupplierGroup, (data, id) => {
        return {
          supplierID: id,
          supplierData: data[0]?.productData?.orgData,
          products: data
        }
      })
      
      // * NO_SHIPPING PRODUCTS AS ONE ORDER
      let noShippingSupplierGroup = groupBy(filter(cartData, cart => {
        return cart.productType == 'NO_SHIPPING'
      }), cartObj => {
        return cartObj.productData.orgID;
      })

      let groupedNoShippingProductCart = map(noShippingSupplierGroup, (data, id) => {
        return {
          supplierID: id,
          supplierData: data[0]?.productData?.orgData,
          products: data
        }
      })

      setAppliedProductVoucher([]);
      setAppliedPlatformVoucher([]);
      // GET VOUCHER LIST FOR ITEMS
      let orderFields: any[] = [];
      // GENERATE FILTER PARAM
      groupedCart.map((product, index) => {
        orderFields.push({
          key: "product",
          orgID: product.supplierID,
          orderTotal: getProductTotal(product),
          shippingFee: (product.shipping?.amount ? product.shipping.amount : 0).toFixed(2),
          products: normalize.model.checkout(product.products)
        });
      });
      // GENERATE FILTER PARAM
      groupedVoucherCart.map((voucher, index) => {
        orderFields.push({
          includeShipping: false,
          key: "voucher",
          orgID: voucher.supplierID,
          orderTotal: getProductTotal(voucher),
          shippingFee: (0).toFixed(2),
          products: normalize.model.checkout(voucher.products)
        })
      })
      // * NO SHIPPING PRODUCTS
      groupedNoShippingProductCart.map((noShippingProduct, index) => {
        orderFields.push({
          includeShipping: false,
          key: "no_shipping",
          orgID: noShippingProduct.supplierID,
          orderTotal: getProductTotal(noShippingProduct),
          shippingFee: (0).toFixed(2),
          products: normalize.model.checkout(noShippingProduct.products)
        })
      })

      fetchItemVoucherList({
        type: "ORDER",
        sourceSite: process.env.ACCOUNT_TYPE,
        orderFields
      });

      setGroupedList(groupedCart);
      setVoucherGroupedList(groupedVoucherCart);
      setNoShippingProductGroupedList(groupedNoShippingProductCart);
      setInput({
        ...input,
        totalAmount: totalAmount,
        totalShipping: totalShipping,
        totalToPay: totalAmount + totalShipping
      });

      // GET PLATFORM VOUCHER LIST
      fetchPlatformVoucherList(totalAmount);
    }
  }, [cartData, shippingCosts]);

  useEffect(() => {
    if (!isNil(profileInfoObj)) {
      if (!input?.shippingAddress?.street1) {
        setInput({ ...input, 'shippingAddress': profileInfoObj.primaryAddress })
      }
    }
  }, [profileInfoObj])

  const onProductClick = (inventory) => {
    const inventoryID = encode(inventory.inventoryID);
    history.push('/products/' + inventoryID);
  }


  const onOpenAddressModal = async () => {

    setAddrList([]);
    if (profileInfoObj.addresses == undefined) {
      let newAddress: any = [];
      newAddress = [{
        ...profileInfoObj.primaryAddress,
        id: 0,
      }]
      setAddrList(newAddress);
    } else {
      let selId = 0;
      let newAddress: any = [];
      newAddress = [
        profileInfoObj.primaryAddress,
        ...profileInfoObj.addresses,
      ]
      newAddress = newAddress.map((data, index) => ({
        ...data,
        id: index,
      }))
      setAddrList(newAddress);
    }
    setIsOpen(true);
  }

  useEffect(() => {
    if (profileStatus.update == 'success') {
      setInput({ ...input, 'shippingAddress': addressInput })
      SetselAddress(profileInfoObj.addresses.length)

      var shippingCostItems = cloneDeep(localCartState.shippingCostObj.orders).map((obj) => {
        obj.state = addressInput.state;
        return obj;
      })
      let costObj = {
        orders: shippingCostItems
      }
      setLocalCartState({
        ...localCartState, shippingCostObj: costObj
      });
    }
  }, [profileStatus])

  const addSel = () => {

    let addr: any = addrList[selAddress];
    if (addr.country == 'MY') {
      var shippingCostItems = cloneDeep(localCartState.shippingCostObj.orders).map((obj) => {
        obj.state = addr.state;
        return obj;
      })
      setTimeout(() => {
        let costObj = {
          orders: shippingCostItems
        }
        setLocalCartState({
          ...localCartState, shippingCostObj: costObj
        });
        setAddrList([])
        SetselAddress(selAddress ? selAddress : 0)
      }, 100);
    }
    setInput({ ...input, 'shippingAddress': addrList[selAddress] })
    onCloseModal();
    setTimeout(() => {
      setAddrList([])
      SetselAddress(selAddress ? selAddress : 0)
    }, 100);

  }

  useEffect(() => {
    updateShippingDiscount();
  }, [groupedList]);

  useEffect(() => {
    if (appliedPlatformVoucher.length > 0) {
      handleVoucher({
        type: "platform",
        id: appliedPlatformVoucher[0].id,
        name: appliedPlatformVoucher[0].name,
        applyBoolean: true,
        voucherType: appliedPlatformVoucher[0].voucherType,
        discountType: appliedPlatformVoucher[0].discountType,
        discountValue: appliedPlatformVoucher[0].discountValue,
        supplierID: appliedPlatformVoucher[0].supplierID,
      })
    }
  }, [appliedProductVoucher])

  const onOpenShipmentPopup = (groupObj) => {
    SetShippingModal({
      ...shippingModal,
      selectedData: groupObj,
      isOpen: true
    })
  }

  const updateShippingType = () => {
    let groupedData = cloneDeep(groupedList)
    let totalShipping = 0;
    groupedData = map(groupedData, groupObj => {
      if (groupObj.supplierID == shippingModal?.selectedData.supplierID) {
        groupObj.shipping = selShipping;
      }
      return groupObj;
    })

    forEach(groupedData, groupObj => {
      totalShipping += (parseFloat(groupObj.shipping.amount))
    })

    setInput({
      ...input,
      totalShipping: totalShipping,
      totalToPay: input.totalAmount + totalShipping
    })
    setGroupedList(groupedData);
    onCloseModal();
  }


  const radioBtnChange = (data: any) => {
    setSelShipping(data)
  }


  const openNewAddressPopup = () => {
    setAddressInput(initialAddrInput)
    setNewAddrOpen(true)
  }

  const onCloseModal = () => {
    setAddrList([])
    setIsOpen(false);
    SetShippingModal({ ...shippingModal, isOpen: false })
    setNewAddrOpen(false)
    setTimeout(() => {
      fetchProfileData();
    }, 2000);
  }


  const handleSelectChange = (value: string | string[], name: string) => {
    if (typeof (value) == 'string') {
      setError(initalError)
      setAddressInput({ ...addressInput, [name]: value });
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setError(initalError)
    setAddressInput({ ...addressInput, [e.target.name]: e.target.value });
  }


  const addAddress = () => {
    try {
      const value = UpdateAddressFormSchema.validateSync(omitBy({
        ...addressInput
      }, (value) => isNil(value) || value === ''), {
        strict: true,
        abortEarly: true,
        stripUnknown: false
      });

      if (!isEmpty(value)) {
        let profileObj: any = profileInfoObj;
        let addressObj: any = addressInput;

        addressObj.street1 = addressObj.addressLine1;
        addressObj.street2 = addressObj.addressLine2;

        if (profileObj.addresses == undefined) {
          profileObj.addresses = [];
          profileObj.addresses[0] = addressObj;
        } else {
          profileObj.addresses.push(addressObj)
        }
        let reqObj = {
          profile: normalize.model.user(profileObj)
        }
        handleUpdate(reqObj)
        onCloseModal()

      }
    } catch (err) {
      const { path, value }: any = errorHandler.validation(err);
      setError({
        ...isError,
        [path]: t(`${value}`, { field: t(`label.${path}`, { context: 'profile' }) })
      });

      if (document.querySelector(`input[name=${path}]`)) {
        (document.querySelector(`input[name=${path}]`) as HTMLInputElement).focus();
      } else if (document.querySelector(`div[name=${path}]`)) {
        (document.querySelector(`div[name=${path}] input`) as HTMLInputElement).focus();
      }
    }
  }

  const roundingBy2Decimals = (num: number) => {
    const rounded = parseFloat(Math.round(num * 100) / 100);
    return rounded.toFixed(2);
  }

  const onPlaceOrder = async () => {
    // if (input?.shippingAddress?.id) {
    //   delete input.shippingAddress.id
    // }
    const isCancelPreviousOrder = history.location?.state?.isCancelPreviousOrder;
    const cancelOrderObjList = history.location?.state?.cancelOrderObjList;
    if (isCancelPreviousOrder && cancelOrderObjList) {
      for (const cancelOrderObj of cancelOrderObjList) {
        const cancelObj = {
          orderID: cancelOrderObj._id,
          newStatus: 'CANCELLED'
        }
        await cancelOrder(cancelObj)
      }
    }

    if (appliedPlatformVoucher.length + appliedProductVoucher.length <= 2) {
      let orderList: any = [];
      let totalShippingFees = 0;
      forEach(groupedList, (groupObj, i) => {
        let orderTotal = 0;
        let items = map(groupObj.products, cartObj => {
          let itemAmount = (parseFloat(cartObj.quantity) * parseFloat(cartObj.selectedVariant.value));
          orderTotal += itemAmount;
          return {
            inventoryID: cartObj.productData.inventoryID,
            quantity: cartObj.quantity.toString(),
            uom: cartObj.selectedVariant.uom,
            amount: itemAmount.toString(),
            unitPrice: cartObj.selectedVariant.value.toString(),
            itemType: cartObj.productData.product.productType,
            variant: cartObj.selectedVariant.variantName,
            variantCode: cartObj.selectedVariant.variantCode,
            additionalData: { approvalStatus: 'PENDING' },
            weight: (cartObj.weight * parseFloat(cartObj.quantity))
          }
        });
        // INIT VARIABLE VALUES
        let orderDiscount = 0;
        let shippingDiscount = 0;
        const appliedVouchers: any[] = [];
        // GET APPLIED DISCOUNT
        const getAppliedVoucher = getDiscountAmount("product", groupObj?.supplierID);
        // IF THERE IS APPLIED VOUCHER
        if (!isNil(getAppliedVoucher)) {
          appliedVouchers.push({
            voucherCode: getAppliedVoucher.id,
            voucherType: getAppliedVoucher.voucherType,
            discountedValue: calcDiscountAmount(groupObj, "product"),
          })
          // IF TRUE, CHANGE SHIPPING DISCOUNT
          if (getAppliedVoucher.voucherType === "SHIPPING") {
            shippingDiscount = groupObj.shipping.amount - getAppliedVoucher.amount;
          } else {
            orderDiscount = orderTotal - getAppliedVoucher.amount;
          }
        }
        let orderObj = omitBy({
          receiverID: profileInfoObj._id,
          orderedBy: profileInfoObj._id,
          orderDate: moment(),
          supplierID: groupObj.supplierID,
          orderType: 'ECOM_RETAIL',
          items: items || null,
          shippingAddress: input.shippingAddress,
          reqStatus: 'NORMAL',
          quotationID: quotationID || undefined,
          paymentDetails: {
            subTotal: orderTotal.toString(),
            shippingFee: getAppliedVoucher?.voucherType === "SHIPPING" ? getAppliedVoucher.amount : groupObj.shipping.amount.toString(),
            total: (orderTotal + groupObj.shipping.amount - orderDiscount - shippingDiscount).toString(),
            orderDiscount: orderDiscount.toString(),
            shippingDiscount: shippingDiscount.toString(),
            discountedSubtotal: (orderTotal - orderDiscount).toString(),
            appliedVouchers
            // paymentStatus: 'PENDING'
          },
          remarks: input.deliveryInstructions || null,
          status: 'OPEN',
          deliveryInfo: { deliveryType: groupObj.shipping.value }
        }, isNil)
        totalShippingFees += parseFloat(orderObj.paymentDetails.shippingFee)
        orderList.push(orderObj);
      })

      forEach(voucherGroupedList, (groupObj, i) => {
        let orderTotal = 0;
        let items = map(groupObj.products, cartObj => {
          let itemAmount = (parseFloat(cartObj.quantity) * parseFloat(cartObj.selectedVariant.value));
          orderTotal += itemAmount;
          return {
            inventoryID: cartObj.productData.inventoryID,
            quantity: cartObj.quantity.toString(),
            uom: cartObj.selectedVariant.uom,
            amount: itemAmount.toString(),
            unitPrice: cartObj.selectedVariant.value.toString(),
            itemType: cartObj.productData.product.productType,
            variant: cartObj.selectedVariant.variantName,
            variantCode: cartObj.selectedVariant.variantCode,
            additionalData: { approvalStatus: 'PENDING' },
          }
        })

        // INIT VARIABLE
        let orderDiscount = 0;
        let shippingDiscount = 0;
        const appliedVouchers: any[] = [];

        // GET APPLIED VOUCHER
        const getAppliedVoucher = getDiscountAmount("voucher", groupObj?.supplierID);
        // IF NOT EMPTY
        if (!isNil(getAppliedVoucher)) {
          // PUSH VOUCHER
          appliedVouchers.push({
            voucherCode: getAppliedVoucher.id,
            voucherType: getAppliedVoucher.voucherType,
            discountedValue: calcDiscountAmount(groupObj, "voucher"),
          });
          // CHANGE SHIPPING DISCOUNT VALUE IF TRUE
          if (getAppliedVoucher.voucherType === "SHIPPING") {
            shippingDiscount = (groupObj?.shipping?.amount || 0) - getAppliedVoucher.amount;
          } else {
            orderDiscount = orderTotal + (groupObj?.shipping?.amount || 0) - getAppliedVoucher.amount;
          }
        }
        let orderObj = omitBy({
          receiverID: profileInfoObj._id,
          orderedBy: profileInfoObj._id,
          orderDate: moment(),
          supplierID: groupObj.supplierID,
          orderType: 'ECOM_RETAIL',
          items: items || null,
          // shippingAddress: input.shippingAddress,
          reqStatus: 'NORMAL',
          quotationID: quotationID || undefined,
          paymentDetails: {
            subTotal: orderTotal.toString(),
            shippingFee: groupObj?.shipping?.amount?.toString() || '0.00',
            total: (orderTotal + (groupObj?.shipping?.amount || 0) - orderDiscount).toString(),
            orderDiscount: orderDiscount.toString(),
            shippingDiscount: shippingDiscount.toString(),
            discountedSubtotal: (orderTotal - orderDiscount).toString(),
            appliedVouchers
            // paymentStatus: 'PENDING'
          },
          remarks: input.deliveryInstructions || null,
          status: 'OPEN',
          // deliveryInfo: { deliveryType: groupObj?.shipping?.value || null }
        }, isNil)

        orderList.push(orderObj);
      })

      // * FOR NO_SHIPPING Products
      forEach(noShippingProductGroupedList, (groupObj, i) => {
        let orderTotal = 0;
        let items = map(groupObj.products, cartObj => {
          let itemAmount = (parseFloat(cartObj.quantity) * parseFloat(cartObj.selectedVariant.value));
          orderTotal += itemAmount;
          return {
            inventoryID: cartObj.productData.inventoryID,
            quantity: cartObj.quantity.toString(),
            uom: cartObj.selectedVariant.uom,
            amount: itemAmount.toString(),
            unitPrice: cartObj.selectedVariant.value.toString(),
            itemType: cartObj.productData.product.productType,
            variant: cartObj.selectedVariant.variantName,
            variantCode: cartObj.selectedVariant.variantCode,
            additionalData: { approvalStatus: 'PENDING' },
          }
        })

        // INIT VARIABLE
        let orderDiscount = 0;
        let shippingDiscount = 0;
        const appliedVouchers: any[] = [];

        // GET APPLIED VOUCHER
        const getAppliedVoucher = getDiscountAmount("no_shipping", groupObj?.supplierID);
        // IF NOT EMPTY
        if (!isNil(getAppliedVoucher)) {
          // PUSH VOUCHER
          appliedVouchers.push({
            voucherCode: getAppliedVoucher.id,
            voucherType: getAppliedVoucher.voucherType,
            discountedValue: calcDiscountAmount(groupObj, "no_shipping"),
          });
          // CHANGE SHIPPING DISCOUNT VALUE IF TRUE
          if (getAppliedVoucher.voucherType === "SHIPPING") {
            shippingDiscount = (groupObj?.shipping?.amount || 0) - getAppliedVoucher.amount;
          } else {
            orderDiscount = orderTotal + (groupObj?.shipping?.amount || 0) - getAppliedVoucher.amount;
          }
        }
        let orderObj = omitBy({
          receiverID: profileInfoObj._id,
          orderedBy: profileInfoObj._id,
          orderDate: moment(),
          supplierID: groupObj.supplierID,
          orderType: 'ECOM_RETAIL',
          items: items || null,
          // shippingAddress: input.shippingAddress,
          reqStatus: 'NORMAL',
          quotationID: quotationID || undefined,
          paymentDetails: {
            subTotal: orderTotal.toString(),
            shippingFee: groupObj?.shipping?.amount?.toString() || '0.00',
            total: (orderTotal + (groupObj?.shipping?.amount || 0) - orderDiscount).toString(),
            orderDiscount: orderDiscount.toString(),
            shippingDiscount: shippingDiscount.toString(),
            discountedSubtotal: (orderTotal - orderDiscount).toString(),
            appliedVouchers
            // paymentStatus: 'PENDING'
          },
          remarks: input.deliveryInstructions || null,
          status: 'OPEN',
          // deliveryInfo: { deliveryType: groupObj?.shipping?.value || null }
        }, isNil)

        orderList.push(orderObj);
      })

      let discount = 0;
      if (appliedPlatformVoucher.length > 0) {
        discount = appliedPlatformVoucher[0].originalValue - appliedPlatformVoucher[0].amount;
      }
      const appliedPlatformVouchers: any[] = [];
      if (appliedPlatformVoucher.length > 0) {
        appliedPlatformVouchers.push({
          voucherCode: appliedPlatformVoucher[0].id,
          voucherType: appliedPlatformVoucher[0].voucherType,
          discountedValue: roundingBy2Decimals(discount).toString(),
        })
      }

      let submitObj = {
        orders: orderList,
        paymentTotals: {
          subTotal: roundingBy2Decimals(input.totalAmount).toString(),
          shippingFee: roundingBy2Decimals(input.totalShipping).toString(),
          total: roundingBy2Decimals(parseFloat(input.totalToPay) - getTotalDiscountAmount()).toString(),
          appliedPlatformVouchers,
        }
      }

      // <div><span>{t('label.productSubtotal')}</span></div>
      //             <div><span>RM{parseFloat(input.totalAmount).toFixed(2)}</span></div>

      //             <div><span>{t('label.shippingTotal')}</span></div>
      //             <div><span>RM{parseFloat(input.totalShipping).toFixed(2)}</span></div>

      //             <div />
      //             <div>
      //               <span>RM{parseFloat(input.totalToPay).toFixed(2)}</span>
      //             </div>

      const STORAGE_KEY = 'TEMP_CREATE_ORDER_DATA';
      if (process.env.GATEWAY_TYPE === 'REVPAY') {
        localStorage.removeItem(STORAGE_KEY);
        localStorage.setItem( // To be used in proceed page :)
          STORAGE_KEY,
          JSON.stringify({
            ...submitObj,
            ...pick(input, ['totalAmount', 'totalShipping', 'totalToPay'])
          })
        );
      }
      handleSubmit(submitObj);
    } else {
      toaster('error', `${t('toaster.max2Vouchers')}.`)
    }
  }

  // LOOP THROUGH THE ITEMS AND RETURN THE ORDER SUM
  const calcSubTotalPrice = (items, shippingAmount) => {
    let sum = 0;
    if (shippingAmount) {
      sum += shippingAmount;
    }
    items.map(item => {
      sum += (parseFloat(item.selectedVariant.value) * parseFloat(item.quantity))
    });
    return sum.toFixed(2)
  }

  // GET FINAL TOTAL AND RETURN THE AMOUNT
  const getProductTotal = (obj) => {
    let sum = 0;
    obj?.products.map(product => {
      sum += parseFloat(product.quantity) * parseFloat(product.selectedVariant.value)
    })
    return sum.toFixed(2);
  }

  const unAppliedVoucher = (voucher, type, supplierID, index) => {
    // REMOVE THE 
    if (type === "platform") {
      setAppliedPlatformVoucher(appliedPlatformVoucher.filter((item) => item.id !== voucher.id));
    } else {
      const newArr = [...appliedProductVoucher];
      newArr.splice(newArr.findIndex(item => item.type === type && item.supplierID === supplierID), 1)
      setAppliedProductVoucher(newArr);
    }
    // ADJUST DROPDOWN ABSOLUTE POSITION
    handleDropdownPosition(type + "-dropdown", type === "platform" ? 0 : index);
  }

  const handleDropdownPosition = (className: string, index: number) => {
    const inputHeight = (document.getElementsByClassName(className + index)[0] as HTMLElement).offsetHeight;
    const child = (document.getElementsByClassName(className + index)[0] as HTMLElement).querySelector('.dropdown-content') as HTMLElement;
    child.style.top = inputHeight + "px";
  }

  /**
   * Main function to call API and process the output.
   *
   * Generate the input param for the verify API & apply if valid.
   *
   * @param {HandleVoucherInterface}    handleVoucherInput       Handle Voucher Interface.
  */
  const handleVoucher = async (handleVoucherInput: HandleVoucherInterface) => {
    // CLEAR ANY INPUT
    updateVoucherCodeInput("", handleVoucherInput.type, handleVoucherInput.supplierID);
    // INITIALISE INPUT
    const filterInput = {};
    const index = getIndex(handleVoucherInput.type, handleVoucherInput.supplierID);

    // PUSH REQUIRED KEY & VALUE
    filterInput["_id"] = handleVoucherInput.id;

    // PUSH CONDITIONAL FILTERS FOR PLATFORM VOUCHERS
    if (handleVoucherInput.type === "platform") {
      filterInput["total"] = input.totalAmount - getNonShippingAppliedVoucherAmount();
    } else {
      console.log(handleVoucherInput.type)
      if (handleVoucherInput.type === "product") {
        let items: any[] = [];
        // ADD SHIPPING FEE TO FILTER
        if (handleVoucherInput.voucherType === "SHIPPING") {
          filterInput["shippingFee"] = ((groupedList[index].shipping?.amount ? groupedList[index].shipping?.amount.toFixed(2) : "0.00"));
        } else {
          // ADD ORDER TOTAL TO FILTER
          filterInput["total"] = getProductTotal(groupedList[index]);
        }
        // LOOP THROUGH ORDER & PUSH THE VALUES TO THE ITEM FILTER
        groupedList[index].products.map(item => {
          items.push({
            inventoryID: item.productData.inventoryID,
            variant: item.selectedVariant.variantCode,
            qty: item.quantity,
            total: (parseFloat(item.quantity) * parseFloat(item.selectedVariant.value)).toFixed(2)
          })
        })
        filterInput["products"] = items;
      } else if (handleVoucherInput.type === 'no_shipping') {
        let items: any[] = [];
        if (handleVoucherInput.voucherType === "ORDER" || handleVoucherInput.voucherType === "PURCHASE") {
          filterInput["total"] = getProductTotal(noShippingProductGroupedList[index]);
        }
        filterInput["shippingFee"] = "0.00";
        noShippingProductGroupedList[index].products.map(item => {
          items.push({
            inventoryID: item.productData.inventoryID,
            variant: item.selectedVariant.variantCode,
            qty: item.quantity,
            total: (parseFloat(item.quantity) * parseFloat(item.selectedVariant.value)).toFixed(2)
          })
        })
        filterInput["products"] = items;
      } else {
        let items: any[] = [];
        if (handleVoucherInput.voucherType === "ORDER" || handleVoucherInput.voucherType === "PURCHASE") {
          filterInput["total"] = getProductTotal(voucherGroupedList[index]);
        }
        filterInput["shippingFee"] = "0.00";
        voucherGroupedList[index].products.map(item => {
          items.push({
            inventoryID: item.productData.inventoryID,
            variant: item.selectedVariant.variantCode,
            qty: item.quantity,
            total: (parseFloat(item.quantity) * parseFloat(item.selectedVariant.value)).toFixed(2)
          })
        })
        filterInput["products"] = items;
      }
    }
    // CALL VERIFY VOUCHER API
    let amount = await verifyVoucher(filterInput);
    // IF OUTPUT IS VALID & NUMBER
    if (isNumber(amount)) {
      // CHECK IF IS PLATFORM TYPE VOUCHER
      if (handleVoucherInput.type === "platform") {
        // IF THERE IS VOUCHER APPLIED, USE THE LASTEST VOUCHER
        if (appliedPlatformVoucher.length > 0) {
          const updatedObject = appliedPlatformVoucher.map((voucher) =>
            voucher = {
              id: handleVoucherInput.id, name: handleVoucherInput.name, amount,
              voucherType: handleVoucherInput.voucherType,
              discountType: handleVoucherInput.discountType,
              discountValue: handleVoucherInput.discountValue,
              originalValue: input.totalAmount - getNonShippingAppliedVoucherAmount()
            }
          );
          setAppliedPlatformVoucher(updatedObject);
        } else {
          setAppliedPlatformVoucher([...appliedPlatformVoucher,
          {
            id: handleVoucherInput.id, name: handleVoucherInput.name, amount,
            voucherType: handleVoucherInput.voucherType,
            discountType: handleVoucherInput.discountType,
            discountValue: handleVoucherInput.discountValue,
            originalValue: input.totalAmount - getNonShippingAppliedVoucherAmount()
          }
          ]);
        }
      } else {
        // PRODUCT & TELE VOUCHER
        // IF THERE IS A VOUCHER APPLIED FOR THE ORDER
        if (appliedProductVoucher.findIndex(e => e.type === handleVoucherInput.type && e.supplierID === handleVoucherInput.supplierID) > -1) {
          setAppliedProductVoucher((prevState, props) => {
            return prevState.map(voucher => {
              return voucher.type === handleVoucherInput.type && voucher.supplierID === handleVoucherInput.supplierID ?
                {
                  ...voucher,
                  id: handleVoucherInput.id, name: handleVoucherInput.name,
                  type: handleVoucherInput.type, amount,
                  voucherType: handleVoucherInput.voucherType,
                  discountType: handleVoucherInput.discountType,
                  discountValue: handleVoucherInput.discountValue,
                  supplierID: handleVoucherInput.supplierID
                } : voucher
            })
          });
        } else {
          setAppliedProductVoucher([...appliedProductVoucher,
          {
            id: handleVoucherInput.id, name: handleVoucherInput.name,
            type: handleVoucherInput.type, amount,
            voucherType: handleVoucherInput.voucherType,
            discountType: handleVoucherInput.discountType,
            discountValue: handleVoucherInput.discountValue,
            supplierID: handleVoucherInput.supplierID,
          }
          ]);
        }
      }
    }
    // ADJUST DROPDOWN ABSOLUTE POSITION
    handleDropdownPosition(handleVoucherInput.type + "-dropdown", handleVoucherInput.type === "platform" ? 0 : index);
  }

  // GET VOUCHER LIST FOR THE ORDER
  const getVoucherDetails = (type: string, supplierID: string) => {
    let output = checkoutItemVoucherList.filter((voucher) => {
      return voucher.key === type && voucher.orgID === supplierID;
    })[0];
    return output;
  }

  // GET THE APPLIED VOUCHER DETAILS FOR THE ORDER
  const getDiscountAmount = (type: string, supplierID: string) => {
    let selectedVoucher = appliedProductVoucher.filter((voucher) => {
      return voucher.type === type && voucher.supplierID === supplierID;
    })[0];
    // IF NOTHING IS APPLIED, RETURN 0, ELSE RETURN DISCOUNTED AMOUNT
    return selectedVoucher;
  }

  // GET THE INDEX OF THE PRODUCT LIST
  const getIndex = (type: string, supplierID: string) => {
    if (type === "product") {
      return groupedList.findIndex(obj => {
        return (obj.supplierID === supplierID);
      })
    }
    if (type === "voucher") {
      return voucherGroupedList.findIndex(obj => {
        return (obj.supplierID === supplierID);
      });
    }
    if (type === "no_shipping") {
      return noShippingProductGroupedList.findIndex(obj => {
        return (obj.supplierID === supplierID);
      });
    }
  }

  // GET TOTAL DISCOUNT AMOUNT AND RETURN THE AMOUNT
  const getTotalDiscountAmount = () => {
    let totalDiscount = 0;
    let productDiscount = 0;
    // LOOP THROUGH THE APPLIED VOUCHER
    appliedProductVoucher.map(voucher => {
      const productType = voucher.type;
      const index = getIndex(voucher.type, voucher.supplierID);
      // ADD THE DIFF BETWEEN PRODUCT TOTAL AND DISCOUNT AMOUNT
      if (productType === "product") {
        if (voucher.voucherType === "SHIPPING") {
          totalDiscount += parseFloat(groupedList[index]?.shipping?.amount || 0) - voucher.amount;
        } else {
          productDiscount += (parseFloat(getProductTotal(groupedList[index])) - voucher.amount);
          totalDiscount += (parseFloat(getProductTotal(groupedList[index])) - voucher.amount);
        }
      } else if (productType === 'no_shipping') {
        productDiscount += (parseFloat(getProductTotal(noShippingProductGroupedList[index])) - voucher.amount);
        totalDiscount += (parseFloat(getProductTotal(noShippingProductGroupedList[index])) - voucher.amount);
      } else {
        productDiscount += (parseFloat(getProductTotal(voucherGroupedList[index])) - voucher.amount);
        totalDiscount += (parseFloat(getProductTotal(voucherGroupedList[index])) - voucher.amount);
      }
    })
    // CHECK IF THERE IS PLATFORM VOUCHER APPLIED
    if (appliedPlatformVoucher.length > 0) {
      if (appliedPlatformVoucher[0].amount === 0) {
        // IF DISCOUNT UNTIL 0, CALC MAX AMOUNT DISCOUNT AFTER PRODUCT DISCOUNT
        // TO PREVENT DISCOUNT AMOUNT OVER PRODUCT SUM AMOUNT
        totalDiscount += (parseFloat(input.totalAmount) - productDiscount - appliedPlatformVoucher[0].amount);
      } else {
        totalDiscount += appliedPlatformVoucher[0].originalValue - appliedPlatformVoucher[0].amount;
      }
    }
    return Math.round(totalDiscount * 100) / 100
  }

  const getNonShippingAppliedVoucherAmount = () => {
    let totalDiscount = 0;
    // LOOP THROUGH THE APPLIED VOUCHER
    appliedProductVoucher.map(voucher => {
      const productType = voucher.type;
      const index = getIndex(voucher.type, voucher.supplierID);
      // ADD THE DIFF BETWEEN PRODUCT TOTAL AND DISCOUNT AMOUNT
      if (productType === "product") {
        if (voucher.voucherType !== "SHIPPING") {
          totalDiscount += (parseFloat(getProductTotal(groupedList[index])) - voucher.amount);
        }
      } else if (productType === 'no_shipping') {
        totalDiscount += (parseFloat(getProductTotal(noShippingProductGroupedList[index])) - voucher.amount);
      } else {
        totalDiscount += (parseFloat(getProductTotal(voucherGroupedList[index])) - voucher.amount);
      }
    })
    return Math.round(totalDiscount * 100) / 100
  }

  const updateShippingDiscount = () => {
    appliedProductVoucher.map(voucher => {
      if (voucher.voucherType === "SHIPPING") {
        handleVoucher({
          type: voucher.type,
          id: voucher.id,
          name: voucher.name,
          applyBoolean: true,
          voucherType: voucher.voucherType,
          discountType: voucher.discountType,
          discountValue: voucher.discountValue,
          supplierID: voucher.supplierID,
        })
      }
    })
  }

  /**
   * Get Total Products.
   *
   * Return the total quantity of product of the order.
   *
   * @param {object}    obj       Order Object.
   * 
   * @returns {number}            Returns the sum of quantity of the order.
  */
  const getTotalProductNum = (obj) => {
    let qty = 0;
    obj.products.map(product => {
      qty += product.quantity;
    });
    return qty;
  }

  // RETURN PREFIX VOUCHER TEXT
  const returnPrefixVoucherText = (voucher) => {
    let str = "";
    if (voucher.discountType === "FIAT") {
      str += `RM ${voucher.discountValue} OFF `;
    } else {
      str += `${voucher.discountValue}% OFF `;
    }
    str += voucher.voucherType;
    return str;
  }

  /**
   * Apply Voucher On Click/Enter Event.
   *
   * When the user clicks on the the apply button or press enter button in the input.
   *
   * @param {string}    type           Order type [PLATFORM || VOUCHER || PRODUCT].
   * @param {boolean}   applyBoolean   Whether to apply or unapply the voucher.
   * @param {string}    supplierID     Supplier ID of the order.
  */
  const applyVoucherFunc = (type, applyBoolean, supplierID: string) => {
    // SET VALUES FOR VARIABLES
    let list;
    let appliedVoucher;
    if (type === "platform") {
      list = checkoutPlatFormVoucherList;
      appliedVoucher = appliedPlatformVoucher;
    } else {
      list = getVoucherDetails(type, supplierID).vouchers;
      appliedVoucher = appliedProductVoucher;
    }
    // IF THERE IS NO APPLIED VOUCHER
    if (!appliedVoucher.some(e => e.type === "platform" || e.type !== "platform" && e.supplierID === supplierID)) {
      // VALID VOUCHER THAT CAN BE APPLIED
      if (list.length > 0) {
        // FIND & MATCHED THE ENTERED VOUCHER
        let output = list.filter((voucher) => {
          return voucher.voucherCode === getVoucherCodeInput(type, supplierID);
        })[0];
        // IF MATCHED
        if (output) {
          // SET THE VALUES
          const id = output._id;
          const name = output.voucherName;
          const voucherType = output.voucherType;
          const discountType = output.discountType;
          const discountValue = output.discountValue;
          // VERIFY VOUCHER FOR THE AMOUNT
          handleVoucher({
            type,
            id,
            name,
            applyBoolean,
            voucherType,
            discountValue,
            discountType,
            supplierID
          });
          // CLEAR THE INPUT FIELD
          updateVoucherCodeInput("", type, supplierID);
        } else {
          toaster('error', t('label.InvalidVoucher'));
        }
      } else {
        toaster('error', t('label.InvalidVoucher'));
      }
    }
  }

  // FIND THE VOUCHER INPUT VALUE BY THE KEY ORDER TYPE
  const getVoucherCodeInput = (type: string, supplierID: string) => {
    let output = voucherCodeInput.filter((voucher) => {
      return voucher.type === type && voucher.supplierID === supplierID;
    })[0];
    return output ? output.value : "";
  }

  // UPDATE VOUCHER INPUT
  const updateVoucherCodeInput = (eventString: string, type: string, supplierID: string) => {
    // FIND IF THERE IS AN OBJECT CREATED FOR THE INPUT
    let output = voucherCodeInput.filter((voucher) => {
      return voucher.type === type && voucher.supplierID === supplierID;
    })[0];
    if (output) {
      // CREATED
      // UPDATE THE INPUT VALUE OF THE OBJECT WITH THE MATCHED KEY PROPERTY
      const updatedObject = voucherCodeInput.map((inputField) => {
        if (inputField.type === type && inputField.supplierID === supplierID) {
          inputField = {
            value: eventString, type, supplierID
          }
        }
        return inputField;
      });
      setVoucherCodeInput(updatedObject);
    } else {
      // NOT CREATED
      // SET THE INPUT VALUE WITH THE KEY PROPERTY
      setVoucherCodeInput([...voucherCodeInput, {
        value: eventString, type, supplierID
      }]);
    }
  }

  // CALCULATE DISCOUNT AMOUNT
  const calcDiscountAmount = (obj, type) => {
    const products = obj?.products;
    const shippingAmount = obj.shipping?.amount;
    const supplierID = obj?.supplierID;
    if (getDiscountAmount(type, supplierID).voucherType === "SHIPPING") {
      return (parseFloat(shippingAmount) - getDiscountAmount(type, supplierID).amount).toFixed(2)
    } else {
      return (parseFloat(calcSubTotalPrice(products, 0)) -
        getDiscountAmount(type, supplierID).amount).toFixed(2)
    }
  }

  const calcProductDiscountAmount = (supplierID, obj) => {
    const getAppliedVoucher = getDiscountAmount("product", supplierID);
    // IF TRUE, CHANGE SHIPPING DISCOUNT
    if (getAppliedVoucher.voucherType === "SHIPPING") {
      return obj.shipping.amount - getAppliedVoucher.amount;
    } else {
      return parseFloat(calcSubTotalPrice(obj.products, obj.shipping?.amount)) - getAppliedVoucher.amount;
    }
  }

  // RETURN COL SPAN
  const returnColSpan = (type: string, supplierID: string) => {
    return getVoucherDetails(type, supplierID)?.vouchers.length > 0 ?
      { lg: 12, sm: 12, xs: 24 } :
      { lg: 24, sm: 24, xs: 24 }
  }

  // RETURN COL SPAN PLATFORM
  const returnColSpanPlatform = () => {
    return checkoutPlatFormVoucherList.length > 0 ?
      { lg: 12, sm: 12, xs: 24 } :
      { lg: 24, sm: 24, xs: 24 }
  }

  useEffect(() => {
    async function assignDaysOfShipping() {
      const session = getWithExpiry(process.env.APP_SESSION);
      const { accessToken } = session

      const response = await axios({
        method: 'POST',
        url: `${process.env.API_URL}/${process.env.API_VER}/settings/ecom/fetch`,
        data: {},
        headers: { 'Authorization': `Bearer ${accessToken}` }
      })

      const data = response.data?.settings?.defaultDaysToShip

      if (data) {
        setDefaultDaysOfShipping(data)
      }
    }

    assignDaysOfShipping()
  }, [])

  const isQuotationOrder = !!quotationID;

  return (
    <div className="product product-checkout">

      {localCartState.list.length ?

        <Row gutter={16}>

          <div style={{ display: 'flex', gap: '10px' }}>

            <img src='/assets/images/checkout-icon.png' className="checkout-icon" />
            <h3 className="title">{t('pageTitle.checkout')}</h3>

          </div>


          {!groupedList.length ? null : groupedList.map((o: any, i: any) => {
            const supplierID = o.supplierID;

            let productDaysToShip = o.supplierData?.ecomSetting?.daysToShip

            const inStock = Number(productDaysToShip?.inStock || defaultDaysOfShipping.inStock)
            const preOrder = Number(productDaysToShip?.preOrder || defaultDaysOfShipping.preOrder)

            const daysToShipStart = (o.supplierData?.ecomSetting?.vacationOrderHandling === 'PRE_ORDER' ?
              preOrder :
              inStock) as number

            const daysToShipEnd = daysToShipStart + 7

            o.daysOfShipping = {
              start: daysToShipStart,
              end: daysToShipEnd,
            }

            return (
              <div className="shopping-details" style={{ borderRadius: '10px' }} key={i}>
                <Row>
                  <Col span={24}>
                    <Col lg={24} md={24} sm={24} xs={24}>
                      {/* For desktop */}
                      <div className="cart-table m-0 desktop-view">
                        <DataTable
                          rowKey={(record: any) => {
                            return record._id
                          }}
                          columns={columns}
                          dataSource={o.products}
                          title={() => (
                            <div>
                              <img
                                alt={o.supplierData?.name || ''}
                                src={o.supplierData?.image_file?.file_url || '/assets/images/product-placeholder.png'}
                                width={50}
                              />
                              <span className="ml-10">{o.supplierData?.name}</span>
                            </div>
                          )}
                          scroll={{ x: 1000 }}
                        />
                      </div>

                      {/* For Mobile */}
                      <div className="cart-table m-0 mobile-view">
                        <DataTable
                          rowKey={(record: any) => {
                            return record._id
                          }}
                          columns={columnsMobile}
                          dataSource={o.products}
                          title={() => (
                            <div>
                              <img
                                alt={t('alt.logo')}
                                src={o.supplierData?.image_file?.file_url || '/assets/images/product-placeholder.png'}
                                width={50}
                              />
                              <span className="ml-10">{o.supplierData?.name}</span>
                            </div>
                          )}
                          scroll={{ x: 1000 }}
                        />
                      </div>
                    </Col>
                  </Col>
                </Row>
                {
                  !isQuotationOrder && getVoucherDetails("product", supplierID) ?
                    <div className="voucher-table mx-25 pb-15">
                      <Row gutter={[0, 10]}>
                        <Col {...returnColSpan("product", supplierID)}>
                          <div className={`voucher-number mr-8 ${getVoucherDetails("product", supplierID)?.vouchers.length === 0 ? "" : "margin-bottom"}`}>
                            <img src="/assets/images/voucher.svg" />
                            <span>{getVoucherDetails("product", supplierID)?.vouchers.length} {getVoucherDetails("product", supplierID)?.vouchers.length > 1 ? t('label.vouchersAvailable') : t('label.voucherAvailable')}</span>
                          </div>
                        </Col>
                        {
                          getVoucherDetails("product", supplierID)?.vouchers.length > 0 ?
                            <Col lg={12} sm={12} xs={24}>
                              <Row gutter={[10, 10]}>
                                <Col xs={24} sm={24} md={16}>
                                  <div className={`dropdown product-dropdown${i}`}>
                                    {/* 
                                      TO REFER
                                      VALUE: GET VALUE FROM THE ARRAY OF OBJECT WITH THE KEY INPUT
                                      ONCHANGE: PASS THE CHANGED INPUT STRING & TARGET KEY TO UPDATE
                                      ONPASTE: GET CLIPBOARD COPIED VALUE & TARGET KEY TO UPDATE
                                      READONLY: CHECK IF THERE IS VOUCHER LIST, IF EMPTY, READONLY TRUE ELSE CHECK IF THERE IS VOUCHER APPLIED
                                      PLACEHOLER: IF THERE IS APPLIED VOUCHER, HIDE PLACEHOLDER
                                    */}
                                    <Input className="voucher-list-applied" value={getVoucherCodeInput("product", supplierID)}
                                      onChange={e => { updateVoucherCodeInput(e.target.value, "product", supplierID) }} onPaste={e => { updateVoucherCodeInput((e.clipboardData).getData('text'), "product", supplierID), e.preventDefault() }}
                                      onPressEnter={() => applyVoucherFunc("product", true, supplierID)}
                                      readOnly={getVoucherDetails("product", supplierID).vouchers.length === 0 ? true : appliedProductVoucher.some(e => e.type === "product" && e.supplierID === supplierID) ? true : false}
                                      placeholder={appliedProductVoucher.some(e => { return e.type === "product" && e.supplierID === supplierID }) ? "" : `${t('label.voucherInputPlaceholder')}`}
                                      prefix={
                                        <div className="name">
                                          {
                                            appliedProductVoucher.map((voucher, index) => {
                                              return voucher.type === "product" && voucher.supplierID === supplierID ?
                                                <span key={index} style={{
                                                  marginRight:
                                                    `${appliedPlatformVoucher.length - 1 !== index ? "10px" : ""}`
                                                }}>
                                                  {returnPrefixVoucherText(voucher)}
                                                  <CloseCircleOutlined onClick={() => unAppliedVoucher(voucher, "product", supplierID, i)} className="ml-10" />
                                                </span>
                                                : null
                                            })
                                          }
                                        </div>}
                                      suffix={<DownOutlined style={{ alignSelf: "center" }} />}
                                    />
                                    {
                                      isEmpty(getVoucherDetails("product", supplierID).vouchers) ?
                                        null :
                                        <div className="dropdown-content">
                                          <VoucherDeals checkOutPage={true} voucherList={getVoucherDetails("product", supplierID).vouchers}
                                            type={`product`} handleApplyVoucher={handleVoucher} orgId={supplierID} />
                                        </div>
                                    }
                                  </div>
                                </Col>
                                <Col xs={24} sm={24} md={8}>
                                  <div className={`apply-button p-12 ${appliedProductVoucher.some(e => e.type === "product" && e.supplierID === supplierID) ? "applied" : ""}`}
                                    onClick={() => applyVoucherFunc("product", true, supplierID)}>
                                    {
                                      appliedProductVoucher.some(e => e.type === "product" && e.supplierID === supplierID) ?
                                        t('label.Applied') : t('label.Apply')
                                    }
                                  </div>
                                </Col>
                              </Row>
                            </Col> : null
                        }
                      </Row>
                    </div> : null
                }
                <div className="cart-table mr-0">
                  <div className="shipping-labels" style={{ display: 'flex', gap: '10px', marginTop: '12px' }}>
                    <img src='/assets/images/shipping-icon.svg' width={25} />
                    <h3 className="title-table">{t('action.shippingOption')}</h3>
                  </div>
                  <div className="shipping-grid">
                    <div className="shipping-details">
                      <span> </span><br />

                      <Button
                        isLoading={status === "loading"}
                        className="btn-checkout"
                        type="secondary"
                        label={
                          <React.Fragment>
                            <span>{o.shipping.label}</span>
                            {/* <DownOutlined /> */}
                          </React.Fragment>
                        }
                        size="middle"
                      // onClick={() => onOpenShipmentPopup(o)}
                      />
                      <div
                        className="fee-type mt-10">
                        {t('label.receiveBy')}&nbsp;
                        {moment(new Date()).add(o.daysOfShipping?.start, 'days').format('DD MMM')} -&nbsp;
                        {moment(new Date()).add(o.daysOfShipping?.end, 'days').format('DD MMM')}
                      </div>
                    </div>
                    <div className="shipping-amount">
                      <span className="fee-type">{
                        i18n.language === 'ms' ?
                          `${t('label.fee')} ${o.shipping.label}` :
                          `${o.shipping.label} ${t('label.fee')}`}</span>
                      <span
                        className="val color-secondary"><b>RM {parseFloat(o.shipping.amount).toFixed(2)}</b></span>

                    </div>
                  </div>
                </div>
                <div className="product-total-price">
                  <div><span>{t('label.VoucherDiscount')}</span></div>
                  <div><span>RM {
                    isNil(getDiscountAmount("product", supplierID)) ?
                      '0.00' :
                      getDiscountAmount("product", supplierID).voucherType === "SHIPPING" ?
                        (o.shipping?.amount - getDiscountAmount("product", supplierID).amount).toFixed(2) :
                        (parseFloat(calcSubTotalPrice(o.products, 0)) - getDiscountAmount("product", supplierID).amount).toFixed(2)
                  }
                  </span></div>
                  <div><span>{t('label.OrderTotal')} ({getTotalProductNum(o) === 1 ? `1 ${t("txt.item")}` : `${getTotalProductNum(o)} ${t("txt.items")}`}): {o?.selectedVariant?.value}</span></div>
                  <div><span className="amount">RM {isNil(getDiscountAmount("product", supplierID)) ? calcSubTotalPrice(o.products, o.shipping?.amount) : (parseFloat(calcSubTotalPrice(o.products, o.shipping?.amount)) - parseFloat(calcDiscountAmount(o, "product"))).toFixed(2)}</span></div>
                </div>
              </div>)
          })}


          {!voucherGroupedList.length ? null : voucherGroupedList.map((o: any, i: any) => {
            const supplierID = o?.supplierID;
            return (
              <div className="shopping-details" style={{ borderRadius: '10px' }} key={i}>
                <Row>
                  <Col span={24}>
                    <Col lg={24} md={24} sm={24} xs={24}>
                      {/*Desktop View*/}
                      <div className="cart-table m-0 desktop-view">
                        <DataTable
                          rowKey={(record: any) => {
                            return record._id
                          }}
                          columns={columns}
                          dataSource={o.products}
                          title={() => (
                            <div>
                              <img
                                alt={t('alt.logo')}
                                src={o.supplierData?.image_file?.file_url || '/assets/images/product-placeholder.png'}
                                width={50}
                              />
                              <span className="ml-10">{o.supplierData?.name}</span>
                            </div>
                          )}
                          scroll={{ x: 1000 }}
                        />
                        {
                          !isQuotationOrder && getVoucherDetails("voucher", supplierID) ?
                            <div className="voucher-table mx-10 pb-15">
                              <Row gutter={[0, 10]}>
                                <Col {...returnColSpan("voucher", supplierID)}>
                                  <div className={`voucher-number mr-8 ${getVoucherDetails("voucher", supplierID)?.vouchers.length === 0 ? "" : "margin-bottom"}`}>
                                    <img src="/assets/images/voucher.svg" />
                                    <span>{getVoucherDetails("voucher", supplierID)?.vouchers.length} {t('label.voucherAvailable')}</span>
                                  </div>
                                </Col>
                                {
                                  getVoucherDetails("voucher", supplierID)?.vouchers.length > 0 ?
                                    <Col lg={12} sm={12} xs={24}>
                                      <Row gutter={[10, 10]}>
                                        <Col xs={24} sm={24} md={16}>
                                          <div className={`dropdown voucher-dropdown${i}`}>
                                            {/* 
                                              FIND [TO REFER]
                                            */}
                                            <Input className="voucher-list-applied" value={getVoucherCodeInput("voucher", supplierID)}
                                              onChange={e => { updateVoucherCodeInput(e.target.value, "voucher", supplierID) }} onPaste={e => { updateVoucherCodeInput((e.clipboardData).getData('text'), "voucher", supplierID), e.preventDefault() }}
                                              onPressEnter={() => applyVoucherFunc("voucher", true, supplierID)}
                                              readOnly={getVoucherDetails("voucher", supplierID).vouchers.length === 0 ? true : appliedProductVoucher.some(e => e.type === "voucher" && e.supplierID === supplierID) ? true : false}
                                              placeholder={appliedProductVoucher.some(e => e.type === "voucher" && e.supplierID === supplierID) ? "" : `${t('label.voucherInputPlaceholder')}`}
                                              prefix={
                                                <div className="name">
                                                  {
                                                    appliedProductVoucher.map((voucher, index) => {
                                                      return voucher.type === "voucher" && voucher.supplierID === supplierID ?
                                                        <span key={index}>
                                                          {returnPrefixVoucherText(voucher)}
                                                          <CloseCircleOutlined onClick={() => unAppliedVoucher(voucher, "voucher", supplierID, i)} className="ml-10" />
                                                        </span>
                                                        : null
                                                    })
                                                  }
                                                </div>}
                                              suffix={<DownOutlined style={{ alignSelf: "center" }} />}
                                            />
                                            {
                                              isEmpty(getVoucherDetails("voucher", supplierID).vouchers) ?
                                                null :
                                                <div className="dropdown-content">
                                                  <VoucherDeals checkOutPage={true} voucherList={getVoucherDetails("voucher", supplierID).vouchers}
                                                    type={`voucher`} handleApplyVoucher={handleVoucher} orgId={supplierID} />
                                                </div>
                                            }
                                          </div>
                                        </Col>
                                        <Col xs={24} sm={24} md={8}>
                                          <div className={`apply-button p-12 ${appliedProductVoucher.some(e => e.type === "voucher" && e.supplierID === supplierID) ? "applied" : ""}`}
                                            onClick={() => applyVoucherFunc("voucher", true, supplierID)}>
                                            {
                                              appliedProductVoucher.some(e => e.type === "voucher" && e.supplierID === supplierID) ?
                                                t("label.Applied") : t("label.Apply")
                                            }
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col>
                                    : null
                                }
                              </Row>
                            </div> : null
                        }
                      </div>
                      {/*Mobile View*/}
                      <div className="cart-table m-0 mobile-view">
                        <DataTable
                          rowKey={(record: any) => {
                            return record._id
                          }}
                          columns={columnsMobile}
                          dataSource={o.products}
                          title={() => (
                            <div>
                              <img
                                alt={t('alt.logo')}
                                src={o.supplierData?.image_file?.file_url || '/assets/images/product-placeholder.png'}
                                width={50}
                              />
                              <span className="ml-10">{o.supplierData?.name}</span>
                            </div>
                          )}
                          scroll={{ x: 1000 }}
                        />
                        {
                          !isQuotationOrder && getVoucherDetails("voucher", supplierID) ?
                            <div className="voucher-table mx-10 pb-15">
                              <Row gutter={[0, 10]}>
                                <Col {...returnColSpan("voucher", supplierID)}>
                                  <div className={`voucher-number mr-8 ${getVoucherDetails("voucher", supplierID)?.vouchers.length === 0 ? "" : "margin-bottom"}`}>
                                    <img src="/assets/images/voucher.svg" />
                                    <span>{getVoucherDetails("voucher", supplierID)?.vouchers.length} {t('label.voucherAvailable')}</span>
                                  </div>
                                </Col>
                                {
                                  getVoucherDetails("voucher", supplierID)?.vouchers.length > 0 ?
                                    <Col lg={12} sm={12} xs={24}>
                                      <Row gutter={[10, 10]}>
                                        <Col xs={24} sm={24} md={16}>
                                          <div className={`dropdown voucher-dropdown${i}`}>
                                            {/* 
                                              FIND [TO REFER]
                                            */}
                                            <Input className="voucher-list-applied" value={getVoucherCodeInput("voucher", supplierID)}
                                              onChange={e => { updateVoucherCodeInput(e.target.value, "voucher", supplierID) }}
                                              onPaste={e => { updateVoucherCodeInput((e.clipboardData).getData('text'), "voucher", supplierID), e.preventDefault() }}
                                              onPressEnter={() => applyVoucherFunc("voucher", true, supplierID)}
                                              readOnly={getVoucherDetails("voucher", supplierID).vouchers.length === 0 ? true : appliedProductVoucher.some(e => e.type === "voucher" && e.supplierID === supplierID) ? true : false}
                                              placeholder={appliedProductVoucher.some(e => e.type === "voucher" && e.supplierID === supplierID) ? "" : `${t('label.voucherInputPlaceholder')}`}
                                              prefix={
                                                <div className="name">
                                                  {
                                                    appliedProductVoucher.map((voucher, index) => {
                                                      return voucher.type === "voucher" && voucher.supplierID === supplierID ?
                                                        <span key={index}>
                                                          {returnPrefixVoucherText(voucher)}
                                                          <CloseCircleOutlined onClick={() => unAppliedVoucher(voucher, "voucher", supplierID, i)} className="ml-10" />
                                                        </span>
                                                        : null
                                                    })
                                                  }
                                                </div>}
                                              suffix={<DownOutlined style={{ alignSelf: "center" }} />}
                                            />
                                            {
                                              isEmpty(getVoucherDetails("voucher", supplierID).vouchers) ?
                                                null :
                                                <div className="dropdown-content">
                                                  <VoucherDeals checkOutPage={true} voucherList={getVoucherDetails("voucher", supplierID).vouchers}
                                                    type={`voucher`} handleApplyVoucher={handleVoucher} orgId={supplierID} />
                                                </div>
                                            }
                                          </div>
                                        </Col>
                                        <Col xs={24} sm={24} md={8}>
                                          <div className={`apply-button p-12 ${appliedProductVoucher.some(e => e.type === "voucher" && e.supplierID === supplierID) ? "applied" : ""}`}
                                            onClick={() => applyVoucherFunc("voucher", true, supplierID)}>
                                            {
                                              appliedProductVoucher.some(e => e.type === "voucher" && e.supplierID === supplierID) ?
                                                t("label.Applied") : t("label.Apply")
                                            }
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col> : null
                                }
                              </Row>
                            </div> : null
                        }
                      </div>
                      <div className="product-total-price mt-15">
                        <div><span>{t('label.VoucherDiscount')}</span></div>
                        <div><span>RM {isNil(getDiscountAmount("voucher", supplierID)) ? '0.00' : (parseFloat(calcSubTotalPrice(o.products, o.shipping?.amount)) - getDiscountAmount("voucher", supplierID).amount).toFixed(2)}</span></div>

                        <div><span>{t('label.OrderTotal')} ({getTotalProductNum(o) === 1 ? `1 ${t("txt.item")}` : `${getTotalProductNum(o)} ${t("txt.items")}`}):</span></div>
                        <div><span className="amount">RM {isNil(getDiscountAmount("voucher", supplierID)) ? calcSubTotalPrice(o.products, o.shipping?.amount) : getDiscountAmount("voucher", supplierID)?.amount.toFixed(2)}</span></div>
                      </div>
                    </Col>
                  </Col>
                </Row>
              </div>)
          })}

          {!noShippingProductGroupedList.length ? null : noShippingProductGroupedList.map((o: any, i: any) => {
            const supplierID = o?.supplierID;
            return (
              <div className="shopping-details" style={{ borderRadius: '10px' }} key={i}>
                <Row>
                  <Col span={24}>
                    <Col lg={24} md={24} sm={24} xs={24}>
                      {/*Desktop View*/}
                      <div className="cart-table m-0 desktop-view">
                        <DataTable
                          rowKey={(record: any) => {
                            return record._id
                          }}
                          columns={columns}
                          dataSource={o.products}
                          title={() => (
                            <div>
                              <img
                                alt={t('alt.logo')}
                                src={o.supplierData?.image_file?.file_url || '/assets/images/product-placeholder.png'}
                                width={50}
                              />
                              <span className="ml-10">{o.supplierData?.name}</span>
                            </div>
                          )}
                          scroll={{ x: 1000 }}
                        />
                        {
                          !isQuotationOrder && getVoucherDetails("no_shipping", supplierID) ?
                            <div className="voucher-table mx-10 pb-15">
                              <Row gutter={[0, 10]}>
                                <Col {...returnColSpan("no_shipping", supplierID)}>
                                  <div className={`voucher-number mr-8 ${getVoucherDetails("no_shipping", supplierID)?.vouchers.length === 0 ? "" : "margin-bottom"}`}>
                                    <img src="/assets/images/voucher.svg" />
                                    <span>{getVoucherDetails("no_shipping", supplierID)?.vouchers.length} {t('label.voucherAvailable')}</span>
                                  </div>
                                </Col>
                                {
                                  getVoucherDetails("no_shipping", supplierID)?.vouchers.length > 0 ?
                                    <Col lg={12} sm={12} xs={24}>
                                      <Row gutter={[10, 10]}>
                                        <Col xs={24} sm={24} md={16}>
                                          <div className={`dropdown no_shipping-dropdown${i}`}>
                                            {/* 
                                              FIND [TO REFER]
                                            */}
                                            <Input className="voucher-list-applied" value={getVoucherCodeInput("no_shipping", supplierID)}
                                              onChange={e => { updateVoucherCodeInput(e.target.value, "no_shipping", supplierID) }} onPaste={e => { updateVoucherCodeInput((e.clipboardData).getData('text'), "no_shipping", supplierID), e.preventDefault() }}
                                              onPressEnter={() => applyVoucherFunc("no_shipping", true, supplierID)}
                                              readOnly={getVoucherDetails("no_shipping", supplierID).vouchers.length === 0 ? true : appliedProductVoucher.some(e => e.type === "no_shipping" && e.supplierID === supplierID) ? true : false}
                                              placeholder={appliedProductVoucher.some(e => e.type === "no_shipping" && e.supplierID === supplierID) ? "" : `${t('label.voucherInputPlaceholder')}`}
                                              prefix={
                                                <div className="name">
                                                  {
                                                    appliedProductVoucher.map((voucher, index) => {
                                                      return voucher.type === "no_shipping" && voucher.supplierID === supplierID ?
                                                        <span key={index}>
                                                          {returnPrefixVoucherText(voucher)}
                                                          <CloseCircleOutlined onClick={() => unAppliedVoucher(voucher, "no_shipping", supplierID, i)} className="ml-10" />
                                                        </span>
                                                        : null
                                                    })
                                                  }
                                                </div>}
                                              suffix={<DownOutlined style={{ alignSelf: "center" }} />}
                                            />
                                            {
                                              isEmpty(getVoucherDetails("no_shipping", supplierID).vouchers) ?
                                                null :
                                                <div className="dropdown-content">
                                                  <VoucherDeals checkOutPage={true} voucherList={getVoucherDetails("no_shipping", supplierID).vouchers}
                                                    type={`no_shipping`} handleApplyVoucher={handleVoucher} orgId={supplierID} />
                                                </div>
                                            }
                                          </div>
                                        </Col>
                                        <Col xs={24} sm={24} md={8}>
                                          <div className={`apply-button p-12 ${appliedProductVoucher.some(e => e.type === "no_shipping" && e.supplierID === supplierID) ? "applied" : ""}`}
                                            onClick={() => applyVoucherFunc("no_shipping", true, supplierID)}>
                                            {
                                              appliedProductVoucher.some(e => e.type === "no_shipping" && e.supplierID === supplierID) ?
                                                t("label.Applied") : t("label.Apply")
                                            }
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col>
                                    : null
                                }
                              </Row>
                            </div> : null
                        }
                      </div>
                      {/*Mobile View*/}
                      <div className="cart-table m-0 mobile-view">
                        <DataTable
                          rowKey={(record: any) => {
                            return record._id
                          }}
                          columns={columnsMobile}
                          dataSource={o.products}
                          title={() => (
                            <div>
                              <img
                                alt={t('alt.logo')}
                                src={o.supplierData?.image_file?.file_url || '/assets/images/product-placeholder.png'}
                                width={50}
                              />
                              <span className="ml-10">{o.supplierData?.name}</span>
                            </div>
                          )}
                          scroll={{ x: 1000 }}
                        />
                        {
                          !isQuotationOrder && getVoucherDetails("no_shipping", supplierID) ?
                            <div className="voucher-table mx-10 pb-15">
                              <Row gutter={[0, 10]}>
                                <Col {...returnColSpan("no_shipping", supplierID)}>
                                  <div className={`voucher-number mr-8 ${getVoucherDetails("no_shipping", supplierID)?.vouchers.length === 0 ? "" : "margin-bottom"}`}>
                                    <img src="/assets/images/voucher.svg" />
                                    <span>{getVoucherDetails("no_shipping", supplierID)?.vouchers.length} {t('label.voucherAvailable')}</span>
                                  </div>
                                </Col>
                                {
                                  getVoucherDetails("no_shipping", supplierID)?.vouchers.length > 0 ?
                                    <Col lg={12} sm={12} xs={24}>
                                      <Row gutter={[10, 10]}>
                                        <Col xs={24} sm={24} md={16}>
                                          <div className={`dropdown no_shipping-dropdown${i}`}>
                                            {/* 
                                              FIND [TO REFER]
                                            */}
                                            <Input className="voucher-list-applied" value={getVoucherCodeInput("no_shipping", supplierID)}
                                              onChange={e => { updateVoucherCodeInput(e.target.value, "no_shipping", supplierID) }}
                                              onPaste={e => { updateVoucherCodeInput((e.clipboardData).getData('text'), "no_shipping", supplierID), e.preventDefault() }}
                                              onPressEnter={() => applyVoucherFunc("no_shipping", true, supplierID)}
                                              readOnly={getVoucherDetails("no_shipping", supplierID).vouchers.length === 0 ? true : appliedProductVoucher.some(e => e.type === "no_shipping" && e.supplierID === supplierID) ? true : false}
                                              placeholder={appliedProductVoucher.some(e => e.type === "no_shipping" && e.supplierID === supplierID) ? "" : `${t('label.voucherInputPlaceholder')}`}
                                              prefix={
                                                <div className="name">
                                                  {
                                                    appliedProductVoucher.map((voucher, index) => {
                                                      return voucher.type === "no_shipping" && voucher.supplierID === supplierID ?
                                                        <span key={index}>
                                                          {returnPrefixVoucherText(voucher)}
                                                          <CloseCircleOutlined onClick={() => unAppliedVoucher(voucher, "no_shipping", supplierID, i)} className="ml-10" />
                                                        </span>
                                                        : null
                                                    })
                                                  }
                                                </div>}
                                              suffix={<DownOutlined style={{ alignSelf: "center" }} />}
                                            />
                                            {
                                              isEmpty(getVoucherDetails("no_shipping", supplierID).vouchers) ?
                                                null :
                                                <div className="dropdown-content">
                                                  <VoucherDeals checkOutPage={true} voucherList={getVoucherDetails("no_shipping", supplierID).vouchers}
                                                    type={`no_shipping`} handleApplyVoucher={handleVoucher} orgId={supplierID} />
                                                </div>
                                            }
                                          </div>
                                        </Col>
                                        <Col xs={24} sm={24} md={8}>
                                          <div className={`apply-button p-12 ${appliedProductVoucher.some(e => e.type === "no_shipping" && e.supplierID === supplierID) ? "applied" : ""}`}
                                            onClick={() => applyVoucherFunc("no_shipping", true, supplierID)}>
                                            {
                                              appliedProductVoucher.some(e => e.type === "no_shipping" && e.supplierID === supplierID) ?
                                                t("label.Applied") : t("label.Apply")
                                            }
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col> : null
                                }
                              </Row>
                            </div> : null
                        }
                      </div>
                      <div className="product-total-price mt-15">
                        <div><span>{t('label.VoucherDiscount')}</span></div>
                        <div><span>RM {isNil(getDiscountAmount("no_shipping", supplierID)) ? '0.00' : (parseFloat(calcSubTotalPrice(o.products, o.shipping?.amount)) - getDiscountAmount("no_shipping", supplierID).amount).toFixed(2)}</span></div>

                        <div><span>{t('label.OrderTotal')} ({getTotalProductNum(o) === 1 ? `1 ${t("txt.item")}` : `${getTotalProductNum(o)} ${t("txt.items")}`}):</span></div>
                        <div><span className="amount">RM {isNil(getDiscountAmount("no_shipping", supplierID)) ? calcSubTotalPrice(o.products, o.shipping?.amount) : getDiscountAmount("no_shipping", supplierID)?.amount.toFixed(2)}</span></div>
                      </div>
                    </Col>
                  </Col>
                </Row>
              </div>)
          })}

          {groupedList.length ?
          <div className="shopping-details" style={{ borderRadius: '10px' }}>
            <div className="cart-table">
              <div style={{ display: 'flex', gap: '10px', marginBottom: '12px' }}>
                <img src='/assets/images/map-icon.png' width={18} />
                <h3 className="title-table">{t('pageTitle.deliveryAddress')}</h3>
              </div>
              <Row gutter={[16, 10]}>
                <Col lg={6} md={6} sm={24} xs={24} style={{ marginTop: '10px' }}>
                  <span>{profileInfoObj?.fullName} (+{profileInfoObj?.primaryPhone?.countryCode}{profileInfoObj?.primaryPhone?.number})</span>
                </Col>
                <Col lg={10} md={10} sm={24} xs={24} style={{ marginTop: '10px' }}>
                  <span>{input.shippingAddress?.street1}, <span>{input.shippingAddress?.street2 ? input.shippingAddress?.street2 + ', ' : ''}</span> {input.shippingAddress?.postcode}, {input.shippingAddress?.state}</span>
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  <div className='manage-address'>
                    <span className="newBtn" onClick={openNewAddressPopup}
                      style={{ marginTop: '10px' }}>+ {t('action.addNewAddress')}</span>
                    <Button
                      style={{ marginTop: '10px' }}
                      isLoading={status === "loading"}
                      className="btn-checkout"
                      type="secondary"
                      label={
                        <React.Fragment>
                          <span>{t('action.manageAddress')}</span>
                        </React.Fragment>
                      }
                      size="middle"
                      onClick={onOpenAddressModal}
                    />
                  </div>
                </Col>

              </Row>

            </div>
          </div> : null}
          {(groupedList?.length > 0 && input.shippingAddress?.country !== 'MY') ?
            <Row style={{ width: '100%' }}>
              <Col lg={24} md={24} sm={24} xs={24} style={{ marginBottom: '15px', marginTop: '10px' }}>
                <Alert message={t('txt.serviceAvailableInfo')} type="warning" showIcon />
              </Col>
            </Row>
            :
            null
          }

          {
            !isQuotationOrder && 
            <div className="p-10 my-20 platform-voucher-table">
              <Row gutter={[8, 0]}>
                <Col {...returnColSpanPlatform()} className="parent-col">
                  <Row gutter={[10, 10]}>
                    <Col sm={12} xs={24} style={{ "alignSelf": "center" }}>
                      <img src="/assets/images/voucher.svg" />
                      <span className="ml-10">{t('label.PurchaseDiscount')}</span>
                    </Col>
                    <Col sm={12} xs={24} className="align-right">
                      {checkoutPlatFormVoucherList.length} {checkoutPlatFormVoucherList.length > 1 ? t('label.PurchaseVouchersAvailable') : t('label.PurchaseVoucherAvailable')}
                    </Col>
                  </Row>
                </Col>
                {
                  checkoutPlatFormVoucherList.length === 0 ? null :
                    <Col className="parent-col" lg={12} sm={12} xs={24}>
                      <Row gutter={[10, 10]}>
                        <Col xs={24} sm={24} md={16}>
                          <div className="dropdown platform-dropdown0">
                            {/* 
                              FIND [TO REFER]
                            */}
                            <Input className="voucher-list-applied" value={getVoucherCodeInput("platform", "")}
                              onChange={e => { updateVoucherCodeInput(e.target.value, "platform", "") }}
                              onPaste={e => { updateVoucherCodeInput((e.clipboardData).getData('text'), "platform", ""), e.preventDefault() }}
                              onPressEnter={() => applyVoucherFunc("platform", true, "")} readOnly={isEmpty(appliedPlatformVoucher) ? false : true}
                              placeholder={isEmpty(appliedPlatformVoucher) ? `${t('label.voucherInputPlaceholder')}` : ""}
                              prefix={
                                <div className="name">
                                  {
                                    appliedPlatformVoucher.map((voucher, index) => {
                                      return <span key={index} style={{
                                        marginRight:
                                          `${appliedPlatformVoucher.length - 1 !== index ? "10px" : ""}`
                                      }}>
                                        {returnPrefixVoucherText(voucher)}
                                        <CloseCircleOutlined onClick={() => unAppliedVoucher(voucher, "platform", "", 0)} className="ml-10" />
                                      </span>
                                    })
                                  }
                                </div>}
                              suffix={<DownOutlined style={{ alignSelf: "center" }} />}
                            />
                            {
                              isEmpty(checkoutPlatFormVoucherList) ? null :
                                <div className="dropdown-content">
                                  <VoucherDeals checkOutPage={true} voucherList={checkoutPlatFormVoucherList}
                                    type="platform" handleApplyVoucher={handleVoucher} orgId="" />
                                </div>
                            }
                          </div>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <div className={`apply-button p-12 ${appliedPlatformVoucher.length === 0 ? "" : "applied"}`}>
                            {
                              appliedPlatformVoucher.length === 0 ?
                                t("label.Apply") : t("label.Applied")
                            }
                          </div>
                        </Col>
                      </Row>
                    </Col>
                }
              </Row>
            </div>
          }

          {groupedList.length ? <div className="shopping-details" style={{ borderRadius: '10px' }}>
            <div className="cart-table">
              <div style={{ display: 'flex', gap: '10px', marginBottom: '12px' }}>
                <img src='/assets/images/note-icon.svg' width={25} />
                <h3 className="title-table">{t('pageTitle.deliveryInstructions')}</h3>
              </div>
              <Row gutter={[16, 10]}>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <TextArea
                    rows={6}
                    placeholder={t('txt.PleaseEnterDeliveryInstructionshere')}
                    name="deliveryInstructions"
                    value={input.deliveryInstructions}
                    onChange={(e) => {
                      setInput({ ...input, deliveryInstructions: e.target.value })
                    }}
                  />
                </Col>
              </Row>
            </div>
          </div> : null}

          <div className="shopping-total-items">
            <div className="total-items">
              <div className="shipping-price">
                <div><span>{t('label.productSubtotal')}</span></div>
                <div><span>RM{parseFloat(input.totalAmount).toFixed(2)}</span></div>

                <div><span>{t('label.shippingTotal')}</span></div>
                <div><span>RM{parseFloat(input.totalShipping).toFixed(2)}</span></div>

                <div><span>{t('label.TotalVoucherDiscount')}</span></div>
                <div><span>-RM{getTotalDiscountAmount().toFixed(2)}</span></div>

                <div />
                <div>
                  <span>RM{(parseFloat(input.totalToPay) - getTotalDiscountAmount()).toFixed(2)}</span>
                </div>

                <div />
                <div className="btn-section">
                  {((groupedList?.length && input.shippingAddress?.country == 'MY') || !groupedList?.length) && process.env.GATEWAY_TYPE === 'KIPLEPAY' ?
                    <Button
                      isLoading={status === "loading"}
                      className="btn-checkout"
                      // isDisabled={paymentCode.value !== '' || process.env.GATEWAY_TYPE === 'KIPLEPAY' ? false : true}
                      type="secondary"
                      label={
                        <React.Fragment>
                          <span>{t('action.placeOrder')}</span>
                        </React.Fragment>
                      }
                      size="large"
                      onClick={() => setModalPlaceOrder(true)}
                    // onClick={() => onPlaceOrder()}
                    />
                    : null
                  }

                  {((groupedList?.length && input.shippingAddress?.country == 'MY') || !groupedList?.length) && process.env.GATEWAY_TYPE === 'REVPAY' ?
                    <Button
                      isLoading={status === "loading"}
                      className="btn-checkout"
                      // isDisabled={paymentCode.value !== '' || process.env.GATEWAY_TYPE === 'KIPLEPAY' ? false : true}
                      type="secondary"
                      label={
                        <React.Fragment>
                          <span>{t('action.continue')}</span>
                        </React.Fragment>
                      }
                      size="large"
                      onClick={() => setModalPlaceOrder(true)} /* After Refund is confirm, then uncomment back */
                    // onClick={() => onPlaceOrder()}
                    />
                    : null
                  }
                </div>
              </div>
            </div>
          </div>
        </Row>
        :

        <div className="my-10 m-auto justify-center">
          <div>
            <img
              className="mx-25"
              alt={t('alt.logo')}
              src='/assets/images/empty-order.png'
              width={150}
            />
            <h3 className="color-primary"><strong>{t('txt.noItemsSelectedForCheckout')}</strong>
            </h3>
          </div>
        </div>
      }

      <BasicModal title={t('action.placeOrder')} isClosable={true} isMaskClosable={true}
        isOpen={modalPlaceOrder} onClose={() => setModalPlaceOrder(false)}>
        <div className="cancel-modal">
          <Space direction="vertical" size="middle">
            <Alert
              style={{ textAlign: 'left' }}
              type="info"
              message={(
                <div className="text-blue-300" dangerouslySetInnerHTML={{
                  __html: t('txt.cancelOrderConfirmationDescTwo')
                }} />
              )}
            />
          </Space>

          <Space className="mt-10" size="small">
            <div className="btn">
              <Button
                isLoading={status === "loading"}
                type="default"
                className="cancel-button"
                label={
                  <React.Fragment>
                    <span>{t('action.cancel')}</span>
                  </React.Fragment>
                }
                size="large"
                onClick={() => setModalPlaceOrder(false)}
              />
            </div>
            <div className="btn">
              <Button
                isLoading={status === "loading"}
                type="primary"
                label={
                  <React.Fragment>
                    <span>{t('action.continue')}</span>
                  </React.Fragment>
                }
                size="large"
                onClick={onPlaceOrder}
              />
            </div>
          </Space>
        </div>
      </BasicModal>

      <BasicModal title={t('title.addNewAddress')} isClosable={true} isMaskClosable={true}
        isOpen={newAddrOpen} onClose={onCloseModal}>

        <div id='addresses'>
          <form>
            <Space className="update-profile-form--inner" direction="vertical" size="large">
              <div>
                <SelectInput
                  isError={!!isError.type}
                  label={t('label.type', { context: 'profile' })}
                  name="type"
                  value={addressInput.type}
                  placeholder={t('option.selectOne')}
                  isRequired={true}
                  options={[
                    { value: 'HOME', label: t('option.home') },
                    { value: 'OFFICE', label: t('option.office') },
                    { value: 'WAREHOUSE', label: t('option.warehouse') },
                    // { value: 'RESIDENTIAL', label: t('option.residential') },
                    // { value: 'COMMERCIAL', label: t('option.commercial') },
                  ]}
                  onChange={
                    (value) => handleSelectChange(value, 'type')
                  }

                />

                <AlertBox text={isError.type} />
              </div>
              <div>
                <TextInput
                  isRequired={true}
                  isError={!!isError.addressLine1}
                  label={t('label.addressLine1')}
                  name="addressLine1"
                  value={addressInput.addressLine1}
                  onChange={handleChange}
                />
                <AlertBox text={isError.addressLine1} />
              </div>

              <div>
                <TextInput
                  isError={!!isError.addressLine2}
                  label={t('label.addressLine2')}
                  name="addressLine2"
                  value={addressInput.addressLine2}
                  onChange={handleChange}
                />
                <AlertBox text={isError.addressLine2} />
              </div>


              <Row gutter={16} className="custom-gap">
                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24} className="col-box">
                  {/* <TextInput
                    isRequired={true}
                    isError={!!isError.state}
                    label={t('label.state')}
                    name="state"
                    value={addressInput.state}
                    onChange={handleChange}
                  /> */}

                  <SelectInput
                    isRequired={true}
                    isError={!!isError.state}
                    label={t('label.state')}
                    name="state"
                    placeholder={t('label.state')}
                    value={addressInput.state}
                    onChange={
                      (value: string | string[]) => handleSelectChange(value, 'state')
                    }
                    options={stateOption}
                  />

                  <AlertBox text={isError.state} />
                </Col>

                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24} className="col-box">
                  <SelectInput
                    isReadonly={false}
                    isRequired={true}
                    isError={!!isError.city}
                    label={t('label.city')}
                    name="city"
                    value={addressInput.city}
                    onChange={(value: string | string[]) => handleSelectChange(value, 'city')}
                    options={citiesOption !== null ? citiesOption : []}
                  />
                  <AlertBox text={isError.city} />
                </Col>

                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24} className="col-box">
                  <TextInput
                    isRequired={true}
                    isError={!!isError.postcode}
                    label={t('label.postcode')}
                    name="postcode"
                    value={addressInput.postcode}
                    onChange={handleChange}
                  />
                  <AlertBox text={isError.postcode} />
                </Col>

                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24} className="col-box">
                  <CountrySelector
                    isRequired={true}
                    isError={!!isError.country}
                    label={t('label.country')}
                    name="country"
                    isReadonly={true}
                    value={addressInput.country}
                  // onChange={(value: string) => handleSelectChange(value, 'country')}
                  />
                  <AlertBox text={isError.country} />
                </Col>
              </Row>
            </Space>
            <div className="sub-btn">
              <Button
                isLoading={status === "loading"}
                className="btn-checkout"
                type="secondary"
                label={
                  <React.Fragment>
                    <span>{t('action.submit')}</span>
                  </React.Fragment>
                }
                size="middle"
                onClick={addAddress}
              />

            </div>
          </form>
          {/* <NewAddressForm isError={''} data={addressInput} status='' onChange={() => { }} onCancel={() => { }} onSubmit={() => { }} /> */}
        </div>


      </BasicModal>


      <BasicModal title={t('title.selectShippingOption')} isClosable={true} isMaskClosable={true}
        isOpen={shippingModal.isOpen} onClose={onCloseModal}>

        <div className="addr-modal">

          {shippingOptions.map((data: any, i) => (
            <div className="addr-section">
              <Radio key={i} value={data.label} checked={data.label === selShipping.label}
                onChange={(e) => {
                  radioBtnChange(data)
                }}
              ><p><b>{data.label}</b><span
                className="amount color-secondary">RM {parseFloat(data.amount).toFixed(2)} </span>
                </p>
              </Radio>
            </div>
          ))}

          <div className="sub-btn">
            <Button
              isLoading={status === "loading"}
              className="btn-checkout"
              type="secondary"
              label={
                <React.Fragment>
                  <span>{t('action.confirm')}</span>
                </React.Fragment>
              }
              size="middle"
              onClick={updateShippingType}
            />

          </div>
        </div>
      </BasicModal>


      <BasicModal title={t('title.selectDeliveryAddress')} isClosable={true} isMaskClosable={true}
        isOpen={isOpen} onClose={onCloseModal}>

        <div className="addr-modal">

          {addrList.map((data: any, i) => (
            <div className="addr-section" key={i}>
              <Radio value={data.id} checked={data.id === selAddress} onChange={(e) => {
                SetselAddress(e.target.value)
              }}><p><b>{data.street1}<span>{data?.street2 ? ', ' + data?.street2 + ', ' : ''}</span></b><span
                className="addr-type">{data.type}</span></p>
                <p>{data.postcode} , {data.state}</p>
              </Radio>
            </div>
          ))}

          <div className="sub-btn">
            <Button
              isLoading={status === "loading"}
              className="btn-checkout"
              type="secondary"
              label={
                <React.Fragment>
                  <span>{t('action.confirm')}</span>
                </React.Fragment>
              }
              size="middle"
              onClick={addSel}
            />

          </div>
        </div>
      </BasicModal>


    </div>
  )
}


export default ProductCheckout;
